import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MouseSVG = function MouseSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M25.38,16.86,10.3,2.52A2,2,0,0,0,7,4L7,25a2,2,0,0,0,.89,1.66,1.93,1.93,0,0,0,1.86.15L14,23.16l2.16,5.05a3,3,0,0,0,1.63,1.59,3.07,3.07,0,0,0,1.07.2A2.8,2.8,0,0,0,20,29.75a3,3,0,0,0,1.52-3.89l-2.17-5.08,5.18-.58.29-.08a2,2,0,0,0,.56-3.26Z"
  }));
};
MouseSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MouseSVG);